import { Component, Input } from '@angular/core';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { ExportInterfaceConfigurationTransferType } from 'src/app/base/models/models.swagger.generated';
import { TranslateModule } from '@ngx-translate/core';
import { EmailFormComponent } from '../../../../base/shared/email-form/email-form.component';
import { EnumDropDownListComponent } from '../../../../base/shared/enum-drop-down-list/enum-drop-down-list.component';
import { AppErrorMessagesComponent } from '../../../../base/error-messages/app-error-messages.component';
import { OutputEmailAccountsService } from '../output-email-accounts.service';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { ActivationEmailTemplateFormType } from './activation-email-template-form.type';

@Component({
    selector: 'app-activation-email-template-form',
    templateUrl: './activation-email-template-form.component.html',
    styleUrls: ['./activation-email-template-form.component.scss'],
    imports: [ReactiveFormsModule, DropDownListModule, AppErrorMessagesComponent, EnumDropDownListComponent, EmailFormComponent, TranslateModule]
})
export class ActivationEmailTemplateFormComponent {

  @Input()
  public activationEmailTemplateForm: FormGroup<ActivationEmailTemplateFormType>;

  public TransferType = ExportInterfaceConfigurationTransferType;
  public outputEmailAccountFields = { text: 'accountName', value: 'id' };

  public get outputEmailAccounts() {
    return this.outEmailAccountsService.outputEmailAccounts;
  }

  constructor(private outEmailAccountsService: OutputEmailAccountsService) { }
}
